<template>
  <div class="linked-paths-box" v-if="linkedPaths.length > 0">
    <IslandBadge type="linkedpaths" :draggable="false"></IslandBadge>
    <div class="linked-paths-box-contents">
      <div class="linked-paths-summary">
        <div class="path" v-for="linkedPath in linkedPaths" :key="linkedPath.id">
          <PathPicker :value="linkedPath.id" :fixed="true"></PathPicker>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import PathPicker from './PathPicker.vue';
import IslandBadge from './IslandBadge.vue';
import { PathViewModel } from '@/features/bots/models/designer';
import { useStore } from 'vuex';
import { computed } from 'vue';

const store = useStore();
const linkedPaths = computed<PathViewModel[]>(() => store.getters.linkedPaths);
</script>

<style scoped lang="scss">
.linked-paths-box {
  display: flex;
  position: relative;
  min-height: 60px;
  background: #eadc8e;
  border-radius: 5px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
}

.linked-paths-box-contents {
  flex: 1;
  display: flex;
  position: relative;
  padding: 0.5em;
}

.linked-paths-summary {
  align-self: center;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}

.path {
  display: flex;
  flex-basis: 47%;
  justify-items: center;
  margin: 0.3em 0.3em 0.3em 0.6em;
}
</style>
